import {
  EventsApiResponse,
  PastEventsApiResponse,
  UpcomingEventsApiResponse,
} from './types';

const API_BASE_URL = 'https://vlsiapi.bssoftcrm.com';

// GET API - Fetch events page content
export const fetchEventsContent = async (): Promise<EventsApiResponse> => {
  try {
    const response = await fetch(`${API_BASE_URL}/EventPage`, {
      method: 'GET',
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data: EventsApiResponse = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching events content:', error);
    throw error;
  }
};

// GET API - Fetch past events
export const fetchPastEvents = async (): Promise<PastEventsApiResponse> => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1.0/PastEvent`, {
      method: 'GET',
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data: PastEventsApiResponse = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching past events:', error);
    throw error;
  }
};

// GET API - Fetch upcoming events
export const fetchUpcomingEvents =
  async (): Promise<UpcomingEventsApiResponse> => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/v1.0/UpcomingEvent`, {
        method: 'GET',
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data: UpcomingEventsApiResponse = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching upcoming events:', error);
      throw error;
    }
  };
